import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Handle } from '../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-eje',
  templateUrl: './create-eje.component.html',
  styleUrls: ['./create-eje.component.scss']
})
export class CreateEjeComponent implements OnInit {

  constructor(
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateEjeComponent>,
    public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService) { }
  operacion = 'createeje';
  ideje = '';
  color = '';
  idpais;

  ngOnInit() {
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editeje';
      this.ideje = this.data.eje.ideje;
      this.grupoVal.controls.NOMBRE.setValue(this.data.eje.nombre);
      this.grupoVal.controls.COLOR.setValue(this.data.eje.color);
      this.color = this.data.eje.color;
    } else {
      this.idpais = this.data.eje.IDPAIS;
    }
  }

  save() {
    this.spinner.show();
    let EJE = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      COLOR: this.grupoVal.controls.COLOR.value,
      IDEJE: this.ideje,
      IDPAIS: this.idpais,
      IDPADRE: this.localSave.get('usuarioPGV').IDU, 
      IDAREA: this.localSave.get('usuarioPGV').IDAREA
    }

    this.gateway.save(this.operacion, EJE).then((result) => {
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(30),
       Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")])]),
    COLOR: new FormControl('', Validators.compose([Validators.required,Validators.minLength(7), Validators.maxLength(7)]))
  });

}
